import { ROUTE_ACCOUNT, ROUTE_HEALTH_DATA } from '@/constants/routes';
import setTitleFromLoader from '@/utils/routing/set-title';
import { redirect, RouteObject } from 'react-router-dom';
import Page from './health-data.page';

export const routeHealthData: RouteObject = {
  path: ROUTE_HEALTH_DATA,
  Component: Page,
  loader() {
    if (import.meta.env.VITE_DEPLOYMENT_TARGET === 'PROD') {
      return redirect(`${ROUTE_ACCOUNT}?tab=risk`);
    }
    return setTitleFromLoader('Health Data')();
  },
};
